export default "__VITE_ASSET___oZPvR5L__"